import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <p>© 2023 Marin Umegane</p>
      </div>
    </footer>
  );
}

export default Footer;
